export type Theme = "light" | "dark";
const KEY = "amendie_theme";

/** Explicit user choice, if any. */
export function storedTheme(): Theme | null {
  const v = localStorage.getItem(KEY);
  return v === "light" || v === "dark" ? v : null;
}

/** OS preference (defaults to light when unknown — amendie runs quiet and mostly succeeds). */
export function systemTheme(): Theme {
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

/** Effective theme: explicit choice wins, else follow the OS. */
export function currentTheme(): Theme {
  return storedTheme() ?? systemTheme();
}

function apply(t: Theme): void {
  document.documentElement.dataset.theme = t;
}

/** Persist + apply an explicit choice. */
export function setTheme(t: Theme): void {
  localStorage.setItem(KEY, t);
  apply(t);
}

/** Apply the effective theme at boot (call before first render to avoid a flash). */
export function initTheme(): void {
  apply(currentTheme());
}
